import {
    axiosInstanceCaptchaToken,
    axiosInstanceNoToken,
    axiosInstanceRegisterToken,
    axiosInstanceRegisterTokenV2,
    axiosInstanceToken,
    axiosInstanceV1
} from "../../app/api";
import {
    AuthAdmin,
    AuthToken,
    IAccessTokenResponse,
    IAuthAdminProps,
    IAuthProps,
    IAuthResponse,
    IAuthTokenProps,
    IBindConnectionProps,
    IGetMailCodeProps, IGetPersonProps,
    ILoginResponse,
    IMailSubmitProps,
    IPasswordSubmit,
    IPhoneSubmitProps,
    IRefreshTokenProps,
    IRegisterProps, IReplace,
    IResponse,
    IResponseWithRetryData,
    IRetryPhoneCodeProps,
    ISendPhoneCodeProps,
} from "../../interface/Auth/frontend";
import {
    ICheckConnectionsAdminResponse,
    ICheckConnectionsResponse,
    IConfirmationRequirementsResult,
    IConfirmRecoveryCodeRequest,
    IConnectionResponse,
    IGetRecoveryPhoneResponse, IPersons,
    IRecoverySendCodeEmail,
    IRecoverySendCodeResponse,
    IRegisterFormProps,
    IRegisterFormResponse,
    IRegistrationInitResult,
    IRepeatRecoveryCodeResponse,
    ISearchUserResponse,
    IUpdatePasswordRequest,
    IConfirmRecoveryCodeResponse
} from "../../interface/Auth/backend";
import {AxiosRequestHeaders} from "axios";
import { IStartSecondFactorResponse, IVerifySecondFactorResponse } from "../../interface/Auth/confirmation";


export async function verifyPhone(data: ISendPhoneCodeProps): Promise<IAccessTokenResponse> {
    return axiosInstanceRegisterToken.post<IAccessTokenResponse>('/sign-up/verify-phone', data).then(result => {
        return result.data
    })
}

export async function submitSMS(data: IPhoneSubmitProps): Promise<IResponse> {
    return axiosInstanceRegisterToken.post<IResponse>('/sign-up/submit-sms-code', data)
        .then(result => result.data)
}

export async function retrySMS(data: IRetryPhoneCodeProps): Promise<IResponseWithRetryData> {
    return axiosInstanceRegisterToken.post<IResponseWithRetryData>('/sign-up/repeat-sms-code', data).then(result => {
        return result.data
    })
}

export async function verifyMail(data: IGetMailCodeProps): Promise<IAccessTokenResponse> {
    return axiosInstanceRegisterTokenV2.post<IAccessTokenResponse>('/sign-up/verify-email', data).then(result => result.data)
}

export async function submitMailCode(data: IMailSubmitProps): Promise<IResponse> {
    return axiosInstanceRegisterToken.post<IResponse>('/sign-up/submit-email-code', data).then(result => result.data)
}

export async function retryMailCode(data: IGetMailCodeProps): Promise<IResponseWithRetryData> {
    return axiosInstanceRegisterToken.post<IResponseWithRetryData>('/sign-up/repeat-email-code', data).then(result => result.data)
}

export async function setPassword(data: IPasswordSubmit): Promise<IAccessTokenResponse> {
    const urlSearch = new URLSearchParams(window.location.search)
    const headers: AxiosRequestHeaders = {}
    const token = urlSearch.get('token')
    if (token) {
        headers["Authorization"] = "Bearer " + token
    }
    return axiosInstanceRegisterToken.post<IAccessTokenResponse>('/sign-up/set-password', data, {headers}).then(result => result.data)
}

export async function signIn(token: AuthToken): Promise<ILoginResponse> {
    const params = new URLSearchParams()
    const urlSearch = new URLSearchParams(window.location.search)
    const client_id = urlSearch.get('client_id')
    const redirect_uri = urlSearch.get('redirect_uri')
    if (client_id) {
        params.append('client_id', client_id)
    }
    if (redirect_uri) {
        params.append('redirect_uri', redirect_uri)
    }

    return axiosInstanceNoToken.post<ILoginResponse>('/auth/continue/direct', undefined, {
        params: params,
        headers: {
            Authorization: `Bearer ${token}`
        }
    }).then(result => result.data)
}

export async function refreshToken(data: IRefreshTokenProps): Promise<ILoginResponse> {

    const formData = new FormData();
    formData.append('client_id', data.client_id)
    formData.append('client_secret', data.client_secret)
    formData.append('refresh_token', data.refresh_token)
    formData.append('grant_type', 'refresh_token')

    return axiosInstanceV1.post<ILoginResponse>('/oauth2/token', formData).then(result => result.data)
}

//OAUTH2
export async function auth(token: AuthToken): Promise<IAuthResponse> {
    const params = new URLSearchParams()
    const urlSearch = new URLSearchParams(window.location.search)
    const client_id = urlSearch.get('client_id')
    const redirect_uri = urlSearch.get('redirect_uri')
    const response_type = urlSearch.get('response_type')
    const state = urlSearch.get('state')
    const nonce = urlSearch.get('nonce')

    if (client_id) {
        params.append('client_id', client_id)
    }
    if (redirect_uri) {
        params.append('redirect_uri', redirect_uri)
    }
    if (state) {
        params.append('state', state)
    }
    if (response_type) {
        params.append('response_type', response_type)
    }
    if (nonce) {
        params.append('nonce', nonce)
    }
    return axiosInstanceNoToken.post<IAuthResponse>('/auth/continue/code', undefined, {
        params: params,
        headers: {
            Authorization: `Bearer ${token}`
        }
    }).then(result => {
        return result.data
    })
}

//OAUTH2
export async function authToken(data: IAuthTokenProps): Promise<IAuthResponse> {
    const params = new URLSearchParams()
    const urlSearch = new URLSearchParams(window.location.search)
    params.append('client_id', data.client_id)
    params.append('redirect_uri', data.redirect_uri)
    if (data.state) {
        params.append('state', data.state)
    }
    params.append('response_type', data.response_type)
    const nonce = urlSearch.get('nonce')
    if (nonce) {
        params.append('nonce', nonce)
    }
    return axiosInstanceToken.post<IAuthResponse>('/oauth2/continue', {}, {params: params}).then(result => {
        return result.data
    })
}

export async function logout() {
    return axiosInstanceToken.post('/oauth2/logout').then(result => result.data)
}


export async function searchUser(identity: string) {
    return axiosInstanceCaptchaToken.post<ISearchUserResponse>('password/recovery/person-search', {identity}).then(result => {
        return result.data
    })
}

export async function recoverySendCode(phone: string) {
    return axiosInstanceCaptchaToken.post<IRecoverySendCodeResponse>('password/recovery/send-code', {phone}).then(result => {
        return result.data
    })
}

export async function recoveryEmail(email: string) {
    return axiosInstanceCaptchaToken.post<IRecoverySendCodeEmail>('contact-data/change/send-code', {email}).then(result => {
        return result.data
    })
}

export async function confirmUser(identity: string) {
    return axiosInstanceCaptchaToken.post('password/recovery/person-confirm', {identity}).then(result => {
        return result.data
    })
}

export async function repeatCode(token: string, sentTo: string|null) {
    return axiosInstanceCaptchaToken.post<IRepeatRecoveryCodeResponse>('/password/recovery/repeat-code', {token, phone: sentTo}).then(result => {
        return result.data
    })
}

export async function confirmRecoveryCode(data: IConfirmRecoveryCodeRequest) {
    return axiosInstanceCaptchaToken.post<IConfirmRecoveryCodeResponse>('/password/recovery/confirm-code', data).then(result => {
        return result.data
    })
}

export async function updatePassword(data: IUpdatePasswordRequest) {
    return axiosInstanceCaptchaToken.post('/password/recovery/update-password', data).then(result => {
        return result.data
    })
}

export async function getPhone(token: string) {
    return axiosInstanceToken.get<IGetRecoveryPhoneResponse>(`password/recovery/${token}`).then(result => {
        return result.data
    })
}

export async function verifyCaptcha(captcha: string) {

    return axiosInstanceToken.post<undefined>(`password/recovery/verify-captcha`,
        {g_recaptcha_response: captcha})
}

export async function passportCheck(data: IRegisterProps) {

    const body: IRegisterFormProps = {
        user: {
            phone: data.phone,
            email: data.email,
        },
        person: {
            first_name: data.name,
            last_name: data.surname,
            patronymic: data.patronymic,
            birthdate: data.birthDate,
        },
        identityCard: {
            identity_card_type_id: data.citizenshipId,
            series: data.passportSeries,
            number: data.passportNumber,
        }
    }
    const urlSearch = new URLSearchParams(window.location.search)
    const headers: AxiosRequestHeaders = {}
    const token = urlSearch.get('token')
    if (token) {
        headers["Authorization"] = "Bearer " + token
    }
    return axiosInstanceRegisterToken.post<IRegisterFormResponse>(`sign-up/continue`, body, {headers}).then(res => res.data)
}

export async function checkConnections(data: IAuthProps) {
    const urlSearch = new URLSearchParams(window.location.search)
    const params = new URLSearchParams()
    const client_id = urlSearch.get('client_id')
    const redirect_uri = urlSearch.get('redirect_uri')
    if (client_id) params.append('client_id', client_id)
    if (redirect_uri) params.append('redirect_uri', redirect_uri)
    return axiosInstanceNoToken.post<ICheckConnectionsResponse>(`auth/sign-in`, data, { params })
        .then(res => res.data)
}

export async function verifySecondFactor(operation_id: number, code: string | null, token: string, way_id?: number): Promise<IVerifySecondFactorResponse> {
    return axiosInstanceNoToken.post<{ data: IVerifySecondFactorResponse }>(`/auth/second-factor/verify`, { operation_id, code, way_id }, {
        headers: { Authorization: `Bearer ${token}` }
    }).then(res => res.data.data)
}

export async function startSecondFactor(way: 'sms'|'call'|'callback', token: string): Promise<IStartSecondFactorResponse> {
    return axiosInstanceNoToken.post<{ data: IStartSecondFactorResponse }>(`/auth/second-factor/start`, {way}, {
        headers: { Authorization: `Bearer ${token}` }
    }).then(res => res.data.data)
}

export async function getSecondFactorOperationState(operation_id: number, token: string): Promise<IStartSecondFactorResponse> {
    return axiosInstanceNoToken.get<{ data: IStartSecondFactorResponse }>(`/confirmation/operation-state`, {
        params: { operation_id },
        headers: { Authorization: `Bearer ${token}` }
    }).then(res => res.data.data)
}

// Вход админа под пользователем
export async function checkConnectionsAdmin(data: IAuthAdminProps) {
    const urlSearch = new URLSearchParams(window.location.search)
    const params = new URLSearchParams()
    const client_id = urlSearch.get('client_id')
    const redirect_uri = urlSearch.get('redirect_uri')
    if (client_id) params.append('client_id', client_id)
    if (redirect_uri) params.append('redirect_uri', redirect_uri)
    return axiosInstanceNoToken.post<ICheckConnectionsAdminResponse>(`auth/admin/sign-in`, data, { params }).then(res => res.data)
}

export async function skipConnection(token: AuthToken) {
    return axiosInstanceNoToken.post<IConnectionResponse>(`auth/connect/skip`, undefined, {
        headers: {
            Authorization: `Bearer ${token}`
        }
    }).then(res => res.data)
}

export async function continueConnection(token: AuthToken) {
    return axiosInstanceNoToken.post<IConnectionResponse>(`auth/connect/continue`, undefined, {
        headers: {
            Authorization: `Bearer ${token}`
        }
    }).then(res => res.data)
}

export async function continueConnectionAdmin(data: AuthAdmin) {
    const {id, token} = data
    return axiosInstanceNoToken.post<IConnectionResponse>(`auth/admin/continue`, {id}, {
        headers: {
            Authorization: `Bearer ${token}`
        }
    }).then(res => res.data)
}

export async function replace(data: IReplace) {
    const {id, token} = data
    return axiosInstanceNoToken.post<IConnectionResponse>(`auth/continue/replace`, {id}, {
        headers: {
            Authorization: `Bearer ${token}`
        }
    }).then(res => res.data)
}


export async function bindConnection(data: IBindConnectionProps) {
    return axiosInstanceNoToken.post<IConnectionResponse>(`auth/connect/bind`, data.data, {
        headers: {
            Authorization: `Bearer ${data.token}`
        }
    }).then(res => res.data)
}

export async function getRegistrationInitData(token: string) {
    const headers: AxiosRequestHeaders = {}
    headers["Authorization"] = "Bearer " + token
    return axiosInstanceNoToken.get<IRegistrationInitResult>(`/sign-up/external/fetch`, {headers}).then(res => res.data)
}

export async function getConfirmationRequirements() {
    return axiosInstanceNoToken.get<IConfirmationRequirementsResult>(`/sign-up/confirmation-requirements`).then(res => res.data)
}

export async function getPerson(data: IGetPersonProps): Promise<IPersons> {
    const params = new URLSearchParams()
    params.append(`filter`, data.login)

    return axiosInstanceNoToken.get<IPersons>('auth/admin/passport-user', {
        headers: {
            Authorization: `Bearer ${data.loginAdminToken}`
        },
        params: params
    }).then(result => {
        return {
            data: result.data.data,
        }
    })
}
